export default __webpack_public_path__ + "static/Quickinstallation_Tile_9008_Step_19-1fb4f3c6e776d130f822b9c5988c6f5f.webp";